import { IMetricDataInfo } from '../../ts/models/IMetricInfo';

import { Loadable } from '../models/Loadable';

export type LoadableDataPointsById = {[id: string]: Loadable<Partial<IMetricDataInfo>>};

export interface MetricsDataState {
  dataPointsById: LoadableDataPointsById;
}

export const InitialMetricsDataState: MetricsDataState = {
  dataPointsById: {}
};
